// src/components/ui/spinner.js
import React from 'react';

export function Spinner() {
  return (
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-primary"></div>
  );
}
